import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BudgetRequestStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/budget.request.status.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BudgetRequestStatusTypeEnum} enumeration values */
export const BudgetRequestStatusTypeEnumI18n: EnumI18nInterface<BudgetRequestStatusTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BudgetRequestStatusTypeEnum.DRAFT]: 'Заполнение',
    [BudgetRequestStatusTypeEnum.ON_APPROVAL]: 'Согласование',
    [BudgetRequestStatusTypeEnum.AGREED]: 'Согласован',
    [BudgetRequestStatusTypeEnum.REFUSED]: 'Отказан',
  },
  [I18nLocalesEnum.EN_US]: {
    [BudgetRequestStatusTypeEnum.DRAFT]: 'Draft',
    [BudgetRequestStatusTypeEnum.ON_APPROVAL]: 'On approval',
    [BudgetRequestStatusTypeEnum.AGREED]: 'Agreed',
    [BudgetRequestStatusTypeEnum.REFUSED]: 'Refused',
  },
};
